export default __webpack_public_path__ + "static/media/31.5bb02c50.png";